module.exports = __webpack_public_path__ + "static/img/icon-success-free.1fb81600.png";